/** Friendly UK calendar date, e.g. `29 Jul 2026`. Always pass `en-GB` — never rely on the browser locale. */
export function formatUkDate(iso: string): string {
  return new Date(iso).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

/** Friendly UK date + time, e.g. `29 Jul 2026, 14:30:05`. */
export function formatUkDateTime(iso: string): string {
  return new Date(iso).toLocaleString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  });
}
